import { gql } from 'graphql-tag';

export const GET_CUSTOM_FIELD_VALUES = gql`
  query Id9dd0e2a41e63efe34eed1f7ff90e9511(
    $companyId: ID!
    $customFieldId: ID!
    $customFieldValuesIds: [ID!]
    $search: String
    $after: ID
    $includeArchivedValues: Boolean!
  ) {
    __typename
  }
`;
